import { useMemo } from 'react'
import { aFiltersFind, useAtomValue } from '~/atoms'
import { Client } from '~/models'

export function useClientFind(client: Client) {
  const filtersFind = useAtomValue(aFiltersFind)
  const find = useMemo(() => {
    if (client.filter_by_geography) {
      return {
        location: { $geoWithin: { $geometry: client!.geom } },
        ...filtersFind,
      }
    }
    if (client.find && client.find.$and) {
      const find = {
        ...client.find,
        ...filtersFind,
        $and: [...client.find.$and, ...(filtersFind.$and || [])],
      }
      return find
    }
    return { ...(client.find || {}), ...filtersFind }
  }, [client, filtersFind])

  return find
}
